import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/api";
import i18n from "@/i18n";

const AuthContext = createContext(null);

function applyUserLanguage(u) {
  const lng = u && u.language;
  if (lng && (lng === "nl" || lng === "en")) {
    i18n.changeLanguage(lng);
    try { localStorage.setItem("lang", lng); } catch (e) {}
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      applyUserLanguage(data);
      setUser(data);
    } catch (e) {
      localStorage.removeItem("token");
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required) return data;
    localStorage.setItem("token", data.token);
    applyUserLanguage(data.user);
    setUser(data.user);
    return data;
  };

  const completeMfa = async (temp_token, code) => {
    const { data } = await api.post("/auth/mfa/verify", { temp_token, code });
    localStorage.setItem("token", data.token);
    applyUserLanguage(data.user);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, completeMfa, logout, reload: load }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
